import { useEffect, useState } from "react";

import { useRealtimeScope } from "./useRealtimeScope";

// A viewer in a presence roster (realtime.md §Presence).
export type PresenceViewer = {
  readonly initials: string;
  readonly name: string;
  readonly since: string;
  readonly user_public_id: string;
};

// Subscribe to a `presence:<target>` scope (subscribing is the join) and track
// the roster from `presence.updated` events. Pass `null` to disengage.
export const usePresence = (
  scope: string | null,
): ReadonlyArray<PresenceViewer> => {
  const [viewers, setViewers] = useState<ReadonlyArray<PresenceViewer>>([]);

  // Clear when the target changes; the server sends the fresh roster on the new
  // subscribe.
  useEffect(() => {
    setViewers([]);
  }, [scope]);

  useRealtimeScope(scope, (event) => {
    if (event.kind === "presence.updated") {
      const summary = (event.summary ?? {}) as {
        viewers?: ReadonlyArray<PresenceViewer>;
      };
      setViewers(summary.viewers ?? []);
    }
  });

  return viewers;
};
